/**
 * @module modules/report-page-sk
 * @description <h2><code>report-page-sk</code></h2>
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReportPageSk", {
    enumerable: true,
    get: function() {
        return ReportPageSk;
    }
});
const _html = require("lit/html.js");
const _define = require("../../../elements-sk/modules/define");
const _ElementSk = require("../../../infra-sk/modules/ElementSk");
const _exploresimplesk = require("../explore-simple-sk/explore-simple-sk");
require("../explore-multi-v2-sk/explore-multi-v2-sk");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _traceformatter = require("../trace-details-formatter/traceformatter");
const _errorMessage = require("../errorMessage");
require("../../../elements-sk/modules/spinner-sk");
require("../anomalies-table-sk/anomalies-table-sk");
require("../graph-list-sk/graph-list-sk");
const _cid = require("../cid/cid");
const _upgradeProperty = require("../../../elements-sk/modules/upgradeProperty");
require("../../../elements-sk/modules/icons/camera-roll-icon-sk");
require("../../../elements-sk/modules/icons/help-icon-sk");
const _telemetry = require("../telemetry/telemetry");
const _commit = require("../common/commit");
const _const = require("../const/const");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const weekInSeconds = 7 * 24 * 60 * 60;
let ReportPageSk = class ReportPageSk extends _ElementSk.ElementSk {
    get isV2Enabled() {
        const urlParams = new URLSearchParams(window.location.search);
        // URL parameters take precedence to allow forcing a specific version (V1 vs V2) via links.
        if (urlParams.has('v2')) {
            return urlParams.get('v2') === 'true';
        }
        if (urlParams.has('explore')) {
            return urlParams.get('explore') === 'v2';
        }
        // Fall back to the user's local preference, and then the instance default.
        const localPref = localStorage.getItem('perf:use-explore-v2');
        return localPref !== null ? localPref === 'true' : !!window.perf.default_to_explore_v2;
    }
    setCurrentlyLoading(value) {
        this._currentlyLoading = value;
        this._render();
    }
    stopTimerAndRecord(metric, tags = {}) {
        if (this.pageLoadStart) {
            const duration = (performance.now() - this.pageLoadStart) / 1000;
            _telemetry.telemetry.recordSummary(metric, duration, _object_spread_props(_object_spread({}, tags), {
                url: window.location.href
            }));
            _telemetry.telemetry.increaseCounter(_telemetry.CountMetric.ReportPageVisit);
            this.pageLoadStart = 0;
        }
    }
    async connectedCallback() {
        this.pageLoadStart = performance.now();
        super.connectedCallback();
        this.updatePageTitle();
        if (this._initialized || this._allGraphsLoaded) {
            return;
        }
        this._initialized = true;
        this._connected = true;
        (0, _upgradeProperty.upgradeProperty)(this, 'commitList');
        this._render();
        this.anomaliesTable = this.querySelector('#anomaly-table');
        this.graphList = this.querySelector('#graph-list');
        if (this.graphList) {
            this.graphList.addEventListener('graphs-loaded', ()=>{
                this._allGraphsLoaded = true;
            });
        }
        this.setCurrentlyLoading('Loading configuration...');
        await this.initializeDefaults();
        this.setCurrentlyLoading('Loading anomalies...');
        await this.fetchAnomalies();
        this.addEventListener('anomalies_checked', (e)=>{
            const detail = e.detail;
            const anomalies = detail.anomalies;
            if (this.isV2Enabled) {
                this.updateMultiExploreStateV2(anomalies, detail.checked);
            } else {
                anomalies.forEach((anomaly)=>{
                    this.updateGraphs(anomaly, detail.checked);
                });
            }
        });
        this.stopTimerAndRecord(_telemetry.SummaryMetric.ReportPageLoadTime);
    }
    async fetchAnomalies() {
        const urlParams = new URLSearchParams(window.location.search);
        this.requestAnomalies = urlParams.get('anomalyIDs') === null ? [] : urlParams.get('anomalyIDs').split(',');
        await fetch('/_/anomalies/group_report', {
            method: 'POST',
            body: JSON.stringify({
                rev: urlParams.get('rev') || '',
                anomalyIDs: urlParams.get('anomalyIDs') || '',
                bugID: urlParams.get('bugID') || '',
                anomalyGroupID: urlParams.get('anomalyGroupID') || '',
                sid: urlParams.get('sid') || ''
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(_jsonOrThrow.jsonOrThrow).then(async (json)=>{
            const anomalyList = json.anomaly_list || [];
            this.timerangeMap = json.timerange_map || {};
            this.updatePageTitle();
            const selectedKey = json.selected_keys;
            if (selectedKey && selectedKey.length > 0) {
                this.requestAnomalies.push(...selectedKey);
            }
            this.setCurrentlyLoading('Loading anomalies details and common commits...');
            const loadingPromises = [
                this.initializePage(anomalyList)
            ];
            // Only attempt to fetch and list common commits if the instance is configured
            // for standard integer commit numbers.
            if (json.is_commit_number_based) {
                loadingPromises.push(this.listAllCommits(anomalyList));
            }
            await Promise.all(loadingPromises);
            if (this.isV2Enabled) {
                this.updateMultiExploreStateV2();
            } else if (this.graphList) {
                this.graphList.items = this.anomaliesTable.getCheckedAnomalies().map((anomaly, index)=>({
                        id: anomaly.id,
                        generateGraph: ()=>this.addGraph(anomaly, index)
                    }));
            }
            this.setCurrentlyLoading('');
        }).catch((msg)=>{
            (0, _errorMessage.errorMessage)(msg);
            this.setCurrentlyLoading('');
            this._render();
        });
    }
    async initializePage(anomalies) {
        await this.anomaliesTable.populateTable(anomalies);
        const urlParams = new URLSearchParams(window.location.search);
        // This statement is for when anomalyIDs is set, e.g. anomalyIDs=123,124.
        // Only those anomalies are selected for initial graphing.
        const selected = this.findRequestedAnomalies();
        if (selected.length > 0) {
            this.anomaliesTable.checkSelectedAnomalies(selected);
        } else if (urlParams.has('sid')) {
            _telemetry.telemetry.increaseCounter(_telemetry.CountMetric.SIDRequiringActionTaken, {
                module: 'report-page-sk',
                function: 'initializePage'
            });
            // If 'sid' is requested, user has explicitly specified a set of anomalies from the
            // 'Graph Selected' button. It's okay to assume user wants all of them graphed.
            this.anomaliesTable.initialCheckAllCheckbox();
        }
    }
    async initializeDefaults() {
        await fetch(`/_/defaults/`, {
            method: 'GET'
        }).then(_jsonOrThrow.jsonOrThrow).then((json)=>{
            this.defaults = json;
        });
    }
    async listAllCommits(anomalies) {
        if (anomalies !== undefined && anomalies.length > 0) {
            const commits = [];
            let start = anomalies[0].start_revision;
            let end = anomalies[0].end_revision;
            anomalies.forEach((anomaly)=>{
                if (anomaly.start_revision > start && anomaly.start_revision < end) {
                    start = anomaly.start_revision;
                }
                if (anomaly.end_revision < end && anomaly.end_revision > start) {
                    end = anomaly.end_revision;
                }
            });
            for(let c = end; c >= start; c--){
                commits.push(c);
            }
            const json = await (0, _cid.lookupCids)(commits);
            const commitSlice = json.commitSlice;
            const commitUrlSet = new Set();
            commitSlice.forEach((commit)=>{
                if (!commitUrlSet.has(commit.url)) {
                    this.checkCommitIsRollout(commit);
                }
                commitUrlSet.add(commit.url);
            });
        }
    }
    updatePageTitle() {
        const urlParams = new URLSearchParams(window.location.search);
        const bugID = urlParams.get('bugID');
        const anomalyIDs = urlParams.get('anomalyIDs');
        const anomalyGroupID = urlParams.get('anomalyGroupID');
        const sid = urlParams.get('sid');
        let title = 'Report';
        if (bugID) {
            title = `Report for bug: ${bugID}`;
        } else if (anomalyIDs) {
            title = `Report for anomalies: ${anomalyIDs}`;
        } else if (anomalyGroupID) {
            title = `Report for anomaly group: ${anomalyGroupID}`;
        } else if (sid) {
            title = `Report for selected: ${sid}`;
        }
        document.title = title;
    }
    // Visible for testing
    redirect(url) {
        window.location.href = url;
    }
    getQueryFromAnomaly(anomaly) {
        return this.traceFormatter.formatQuery(anomaly.test_path);
    }
    addGraph(anomaly, index = -1) {
        const explore = this.exploreSimpleSkFactory();
        explore.defaults = this.defaults;
        explore.openQueryByDefault = false;
        explore.navOpen = false;
        explore.enableRemoveButton = false;
        explore.is_chart_split = true;
        explore.state.plotSummary = true;
        explore.tracesRendered = true;
        explore.isReportPage = true;
        const query = this.getQueryFromAnomaly(anomaly);
        const state = new _exploresimplesk.State();
        state.plotSummary = true;
        const timerange = this.timerangeMap[anomaly.id];
        explore.state = _object_spread_props(_object_spread({}, state), {
            queries: [
                query
            ],
            highlight_anomalies: [
                anomaly.id
            ],
            // show 1 week's worth of data before and after
            // showing more data helps users determine
            // if a regression has already been mitigated
            begin: timerange.begin - weekInSeconds,
            end: timerange.end + weekInSeconds,
            // the requestType controls how many data points to query.
            // 0 means to query data points between the begin and end timestamps
            // 1 means to query State().numCommits number of data points
            // Set to 0 to promote symmetry.
            requestType: 0,
            graph_index: index > -1 ? index : this.graphList ? this.graphList.items.length : 0
        });
        return explore;
    }
    updateGraphs(anomaly, checked) {
        if (!this._allGraphsLoaded || !this.graphList) {
            return;
        }
        if (checked) {
            this.graphList.addGraph({
                id: anomaly.id,
                generateGraph: ()=>this.addGraph(anomaly)
            });
        } else {
            this.graphList.removeGraph(anomaly.id);
        }
    }
    parseAnomalyPathToParamSet(path) {
        return this.traceFormatter.formatParamSet(path);
    }
    applyDefaultsToParamSet(query) {
        var _this_defaults;
        const defaultParams = (_this_defaults = this.defaults) === null || _this_defaults === void 0 ? void 0 : _this_defaults.default_param_selections;
        if (!defaultParams) {
            return query;
        }
        const result = _object_spread({}, query);
        for (const [key, val] of Object.entries(defaultParams)){
            var _window_perf;
            if (((_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.remove_default_stat_value) && key === 'stat') {
                continue;
            }
            if (!Object.keys(result).includes(key) && val !== null) {
                result[key] = [
                    ...val
                ];
            }
        }
        return result;
    }
    getSortedQueryString(query) {
        const sortedQuery = {};
        Object.keys(query).sort().forEach((key)=>{
            sortedQuery[key] = [
                ...query[key]
            ].sort();
        });
        return JSON.stringify(sortedQuery);
    }
    isEmptyWithDefaults(query, defaultQuery) {
        const defaults = defaultQuery || this.applyDefaultsToParamSet({});
        return this.getSortedQueryString(query) === this.getSortedQueryString(defaults);
    }
    getCommonPathGroupKey(testPath) {
        if (testPath.includes('/')) {
            const trimmed = testPath.replace(/\/+$/, '');
            const lastSlash = trimmed.lastIndexOf('/');
            return lastSlash !== -1 ? trimmed.substring(0, lastSlash) : trimmed;
        }
        if (testPath.startsWith(',') || testPath.includes('=')) {
            const parts = testPath.split(',').filter(Boolean);
            const prefixParts = parts.filter((p)=>!p.startsWith('test=') && !p.startsWith('subtest_') && !p.startsWith('stat='));
            if (prefixParts.length > 0) {
                return ',' + prefixParts.join(',') + ',';
            }
            if (parts.length > 1) {
                return ',' + parts.slice(0, -1).join(',') + ',';
            }
        }
        return testPath;
    }
    mergeAnomalyQueries(anomalies) {
        const merged = {};
        anomalies.forEach((anomaly)=>{
            const parsed = this.applyDefaultsToParamSet(this.parseAnomalyPathToParamSet(anomaly.test_path));
            for (const [key, values] of Object.entries(parsed)){
                if (!merged[key]) {
                    merged[key] = [];
                }
                for (const val of values){
                    if (!merged[key].includes(val)) {
                        merged[key].push(val);
                    }
                }
            }
        });
        return merged;
    }
    updateMultiExploreStateV2(_toggledAnomalies, _checked) {
        if (!this.isV2Enabled) return;
        const selectedAnomalies = this.anomaliesTable ? this.anomaliesTable.getCheckedAnomalies() : [];
        this._highlightAnomaliesV2 = selectedAnomalies.map((a)=>a.id);
        if (selectedAnomalies.length === 0) {
            this._queriesV2 = [
                this.applyDefaultsToParamSet({})
            ];
            this._splitKeysV2 = new Set();
            this._viewportMinXV2 = null;
            this._viewportMaxXV2 = null;
            this._beginV2 = _const.UNSET_TIME;
            this._endV2 = _const.UNSET_TIME;
            this._render();
            return;
        }
        const multiExplore = this.querySelector('#multi-explore');
        // Group selected anomalies by common path
        const groupsMap = new Map();
        selectedAnomalies.forEach((anomaly)=>{
            const groupKey = this.getCommonPathGroupKey(anomaly.test_path);
            if (!groupsMap.has(groupKey)) {
                groupsMap.set(groupKey, []);
            }
            groupsMap.get(groupKey).push(anomaly);
        });
        const mergedQueries = [];
        groupsMap.forEach((anomaliesInGroup)=>{
            mergedQueries.push(this.mergeAnomalyQueries(anomaliesInGroup));
        });
        this._queriesV2 = mergedQueries.length > 0 ? mergedQueries : [
            this.applyDefaultsToParamSet({})
        ];
        // --- Update _splitKeysV2, _viewportMinXV2, _viewportMaxXV2, _beginV2, _endV2 ---
        const shouldPreserveMultiExploreState = multiExplore && multiExplore.splitKeys && multiExplore.viewportMinX !== null;
        if (shouldPreserveMultiExploreState) {
            this._splitKeysV2 = multiExplore.splitKeys;
            this._viewportMinXV2 = multiExplore.viewportMinX;
            this._viewportMaxXV2 = multiExplore.viewportMaxX;
            this._beginV2 = multiExplore.begin;
            this._endV2 = multiExplore.end;
            if (multiExplore.onlyRegressions !== undefined) this._onlyRegressionsV2 = multiExplore.onlyRegressions;
            if (multiExplore.splitAll !== undefined) this._splitAllV2 = multiExplore.splitAll;
            if (multiExplore.showSparklines !== undefined) this._showSparklinesV2 = multiExplore.showSparklines;
            if (multiExplore.pageSize !== undefined) this._pageSizeV2 = multiExplore.pageSize;
        } else {
            let minCommit = Infinity;
            let maxCommit = -Infinity;
            let minBegin = Infinity;
            let maxEnd = -Infinity;
            selectedAnomalies.forEach((anomaly)=>{
                if (anomaly.start_revision < minCommit) minCommit = anomaly.start_revision;
                if (anomaly.end_revision > maxCommit) maxCommit = anomaly.end_revision;
                const timerange = this.timerangeMap[anomaly.id];
                if (timerange) {
                    if (timerange.begin < minBegin) minBegin = timerange.begin;
                    if (timerange.end > maxEnd) maxEnd = timerange.end;
                }
            });
            this._splitKeysV2 = new Set();
            this._viewportMinXV2 = Math.max(0, minCommit - 100);
            this._viewportMaxXV2 = maxCommit + 100;
            if (minBegin !== Infinity) {
                this._beginV2 = minBegin - weekInSeconds;
            } else {
                this._beginV2 = _const.UNSET_TIME;
            }
            if (maxEnd !== -Infinity) {
                this._endV2 = maxEnd + weekInSeconds;
            } else {
                this._endV2 = _const.UNSET_TIME;
            }
        }
        this._render();
    }
    _syncFromMultiExplore() {
        const multiExplore = this.querySelector('#multi-explore');
        if (multiExplore) {
            if (multiExplore.onlyRegressions !== undefined) this._onlyRegressionsV2 = multiExplore.onlyRegressions;
            if (multiExplore.splitAll !== undefined) this._splitAllV2 = multiExplore.splitAll;
            if (multiExplore.showSparklines !== undefined) this._showSparklinesV2 = multiExplore.showSparklines;
            if (multiExplore.pageSize !== undefined) this._pageSizeV2 = multiExplore.pageSize;
        }
    }
    // findRequestedAnomalies returns a list of requested anomaly objects .
    // This is for only loading selected untriaged anomaly graphs in the first place.
    findRequestedAnomalies() {
        var _this_anomaliesTable;
        return ((_this_anomaliesTable = this.anomaliesTable) === null || _this_anomaliesTable === void 0 ? void 0 : _this_anomaliesTable.anomalyList.filter((anomaly)=>this.requestAnomalies.includes(anomaly.id))) || [];
    }
    showAllCommitsTemplate() {
        if (this.commitMap.size !== 0) {
            return (0, _html.html)`
        <div class="common-commits">
          <h3>Common Commits</h3>
          <div class="scroll-commits">
            <ul class="table" id="all-commits-scroll">
              ${Array.from(this.commitMap.keys()).slice(0, 10).map((commit)=>{
                return (0, _html.html)` <li>
                    <a href="${commit.url}" target="_blank">${(0, _commit.TrimHash)(commit.hash)}</a>
                    <span id="commit-message">${commit.message}</span>
                    ${this.addIconForRollCommit(commit)}
                  </li>`;
            })}
            </ul>
          </div>
        </div>
      `;
        }
    }
    checkCommitIsRollout(commit) {
        if (commit.message.startsWith('Roll') || commit.message.startsWith('Manual roll')) {
            this.commitMap.set(commit, true);
        } else {
            this.commitMap.set(commit, false);
        }
    }
    addIconForRollCommit(commit) {
        if (this.commitMap.get(commit)) {
            return (0, _html.html)`
        <button
          id="roll-commits-link"
          @click=${()=>{
                this.openUnderlyingCommitUrl(commit);
            }}>
          <camera-roll-icon-sk></camera-roll-icon-sk>
        </button>
      `;
        } else {
            return ``;
        }
    }
    async openUnderlyingCommitUrl(commit) {
        const json = await (0, _cid.lookupCids)([
            commit.offset
        ]);
        const logEntry = json.logEntry;
        let url = '';
        if (this.checkIfCommitMessageFollowsRollPattern(commit.message)) {
            url = this.findInternalCommitUrl(logEntry);
        } else {
            url = this.findParentUrl(logEntry);
        }
        if (url !== '') {
            window.open(url, '_blank');
        } else {
            window.open(commit.url, '_blank');
        }
    }
    // Using Regular Expressions to check whether the commit message
    // follows the pattern, e.g: "Roll repo from hash to hash"
    checkIfCommitMessageFollowsRollPattern(message) {
        const regex = /^.+? from .+? to .+? \(.+?\)$/;
        // Execute the regex against the input string
        const match = regex.exec(message);
        return match ? true : false;
    }
    findInternalCommitUrl(log) {
        // If a match is found, match[1] contains the captured group
        // split the log to each line, find the url right after "Body ")
        const bodyLine = log.split('\n').find((line)=>line.startsWith(this.commitBodyPrefix));
        return bodyLine ? bodyLine.substring(this.commitBodyPrefix.length) : '';
    }
    // When the initial commit message does not follow "Roll"
    findParentUrl(log) {
        const regex = /^Parent (.*)$/m;
        const match = log.match(regex);
        // If a match is found, match[1] contains the captured group (the text after "Parent ")
        if (match && match[1]) {
            // Return parent url with window perf git url prefix
            // Parent url starts after 'Parent '
            // e,g: 'db2e77d1decc3cae2172a7b72c931aa20b4b1d37'
            return this.commitUrlprefix + match[1];
        }
        return '';
    }
    constructor(){
        super(ReportPageSk.template);
        /**
   * Factory for creating ExploreSimpleSk instances. This allows for dependency
   * injection in tests.
   */ this.exploreSimpleSkFactory = ()=>new _exploresimplesk.ExploreSimpleSk(false);
        this.timerangeMap = {};
        // Reference to anomalies table element.
        this.anomaliesTable = null;
        this.graphList = null;
        this._currentlyLoading = 'Loading configuration...';
        this._initialized = false;
        this._allGraphsLoaded = false;
        this.pageLoadStart = 0;
        this.traceFormatter = null;
        this.defaults = null;
        this.commitMap = new Map();
        this.requestAnomalies = [];
        this.commitUrlprefix = window.perf.git_repo_url + '/+show/';
        this.commitBodyPrefix = 'Body ';
        this._queriesV2 = [
            {}
        ];
        this._viewportMinXV2 = null;
        this._viewportMaxXV2 = null;
        this._splitKeysV2 = new Set();
        this._beginV2 = _const.UNSET_TIME;
        this._endV2 = _const.UNSET_TIME;
        this._highlightAnomaliesV2 = [];
        this._onlyRegressionsV2 = true;
        this._splitAllV2 = true;
        this._showSparklinesV2 = false;
        this._pageSizeV2 = 250;
        this.toggleV2Mode = ()=>{
            const urlParams = new URLSearchParams(window.location.search);
            const newUrl = new URL(window.location.href);
            if (this.isV2Enabled) {
                // Opting out of V2: keep only standard report-page parameters
                localStorage.setItem('perf:use-explore-v2', 'false');
                const reportParams = [
                    'sid',
                    'bugID',
                    'anomalyIDs',
                    'anomalyGroupID',
                    'rev'
                ];
                const newParams = new URLSearchParams();
                reportParams.forEach((param)=>{
                    if (urlParams.has(param)) {
                        newParams.set(param, urlParams.get(param));
                    }
                });
                if (window.perf.default_to_explore_v2) {
                    newParams.set('v2', 'false');
                }
                newUrl.search = newParams.toString();
            } else {
                // Opting in to V2: keep existing params and set v2=true
                localStorage.setItem('perf:use-explore-v2', 'true');
                urlParams.set('v2', 'true');
                newUrl.search = urlParams.toString();
            }
            this.redirect(newUrl.toString());
        };
        this.traceFormatter = new _traceformatter.ChromeTraceFormatter();
    }
};
(()=>{
    ReportPageSk.template = (ele)=>(0, _html.html)`
    <div class="title-container">
      <div class="title-left">
        <h1>Anomaly Report</h1>
        <a
          href="https://skia.googlesource.com/buildbot/+/refs/heads/main/perf/report-page-guide.md"
          target="_blank"
          rel="noopener"
          title="Report Page Guide">
          <help-icon-sk></help-icon-sk>
        </a>
      </div>
    </div>
    ${ele._currentlyLoading ? (0, _html.html)`
          <div class="loading-status">
            <spinner-sk id="loading-spinner" active></spinner-sk>
            <span class="loading-message">${ele._currentlyLoading}</span>
          </div>
        ` : ''}
    <anomalies-table-sk
      id="anomaly-table"
      show-requested-groups-first
      .loading=${!!ele._currentlyLoading}>
    </anomalies-table-sk>
    ${ele.showAllCommitsTemplate()}
    ${ele._currentlyLoading ? '' : (0, _html.html)`
          <div
            class="v2-toggle-container"
            style="display: flex; align-items: center; justify-content: flex-end; padding: 8px 16px; gap: 12px; border-radius: 8px; margin: 12px 0; border: 1px solid var(--outline, rgba(255,255,255,0.1)); background-color: rgba(128,128,128,0.05);">
            <span style="font-size: 12px; font-weight: 600; color: var(--on-background, #cbd5e1);"
              >Multi-Trace Anomaly Dashboard V2 (Prototype):</span
            >
            <button
              @click=${ele.toggleV2Mode}
              style="background: ${ele.isV2Enabled ? 'var(--primary, #1a73e8)' : '#475569'}; color: white; border: none; padding: 4px 16px; border-radius: 12px; font-size: 11px; font-weight: bold; cursor: pointer; transition: all 0.2s;">
              ${ele.isV2Enabled ? 'ACTIVE (Click to Disable)' : 'OPT-IN (Click to Enable)'}
            </button>
          </div>
        `}
    ${ele.isV2Enabled ? ele._currentlyLoading ? '' : (0, _html.html)`
            <explore-multi-v2-sk
              id="multi-explore"
              .queries=${ele._queriesV2}
              .splitKeys=${ele._splitKeysV2}
              .dateMode=${false}
              .viewportMinX=${ele._viewportMinXV2}
              .viewportMaxX=${ele._viewportMaxXV2}
              .begin=${ele._beginV2}
              .end=${ele._endV2}
              .highlightAnomalies=${ele._highlightAnomaliesV2}
              .onlyRegressions=${ele._onlyRegressionsV2}
              .splitAll=${ele._splitAllV2}
              .showSparklines=${ele._showSparklinesV2}
              .pageSize=${ele._pageSizeV2}
              @explore-state-change=${()=>ele._syncFromMultiExplore()}
              .embedded=${true}>
            </explore-multi-v2-sk>
          ` : (0, _html.html)`<graph-list-sk id="graph-list"></graph-list-sk>`}
    <div id="bottom-spacer"></div>
  `;
})();
(0, _define.define)('report-page-sk', ReportPageSk);
